import { render, staticRenderFns } from "./radishes-money.vue?vue&type=template&id=7f221f43&"
import script from "./radishes-money.vue?vue&type=script&lang=js&"
export * from "./radishes-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "radishes-money.vue"
export default component.exports